import { ca } from '@cian/analytics';

export function trackOfferRemoved(offerId: number, label: string) {
  ca('event', {
    action: 'delete',
    category: 'AD_DeleteReason',
    event: 'oldevent',
    label,
    oid: offerId,
  });
}
